/**
 * @generated SignedSource<<876729a26dd060ef7a5c5e9b31808218>>
 * @relayHash 211a69c30b4f214a1cccdbd7dfc2fd9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type issueType_issueTypeSearchQuery$variables = {
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  id: string;
};
export type issueType_issueTypeSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef">;
};
export type issueType_issueTypeSearchQuery = {
  response: issueType_issueTypeSearchQuery$data;
  variables: issueType_issueTypeSearchQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider: {
    readonly get: () => boolean;
  };
});

import isInlineManageWorkTypesConfigNinIccEnabled_provider from '@atlassian/jira-relay-provider/src/jira-nin-inline-manage-work-type-config.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterById"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "filterById",
  "variableName": "filterById"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v4/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueType_issueTypeSearchQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "issueType_issueTypeSearchQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      },
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "small"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeId"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v6/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                "kind": "LinkedHandle",
                "name": "issueTypes"
              }
            ],
            "type": "JiraIssueTypeField"
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "54c1a073e9dd218421f63fef52aaa2d1b8e7e0c8707d4d24c135590a7068c68b",
    "metadata": {},
    "name": "issueType_issueTypeSearchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
    }
  }
};
})();

(node as any).hash = "a9ae551cfa917838f44cb5ad82166383";

export default node;
